<template>
  <div id="invoice-view">
    <v-app id="inspire">
      <v-data-table
        :headers="headers"
        :items="invoices"
        sort-by="cost"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-toolbar-title>Upcoming Scrim Matches</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
            <v-spacer />
            <v-dialog
              v-model="dialog"
              max-width="500px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  class="mb-2"
                  v-bind="attrs"
                  v-on="on"
                >
                  New Scrim
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.oppo"
                          label="Opponent"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-select
                          :items="['Planning', 'Confirmed', 'Cancelled']"
                          :menu-props="{ top: true, offsetY: true }"
                          v-model="editedItem.status"
                          label="Status"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.contact"
                          label="Contact"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.location"
                          label="location"
                        />
                      </v-col>
                      <v-col
                        cols="6"
                        sm="6"
                        md="4"
                      >
                        <v-menu
                          ref="menu"
                          v-model="date"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="editedItem.date"
                              label="Picker in menu"
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            v-model="editedItem.date"
                            no-title
                            scrollable
                          >
                            <v-spacer />
                            <v-btn
                              text
                              color="primary"
                              @click="menu = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu.save(date)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="6"
                        md="4"
                      >
                        <v-text-field
                          v-model="editedItem.links"
                          label="External Links"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="close"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    @click="save"
                  >
                    Save
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            :color="getColor(item.status)"
            dark
          >
            {{ item.status }}
          </v-chip>
        </template>

        <template v-slot:item.actions="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editItem(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="deleteItem(item)"
          >
            mdi-delete
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-btn
            color="primary"
            @click="initialize"
          >
            Reset
          </v-btn>
        </template>
      </v-data-table>
    </v-app>
  </div>
</template>

<script>
  export default {
    name: 'MatchView',

    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Match',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Opponent', value: 'oppo' },
        { text: 'Status', value: 'status' },
        { text: 'Contact', value: 'contact' },
        { text: 'Location', value: 'location' },
        { text: 'Date', value: 'date' },
        { text: 'External Links', value: 'links', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      invoices: [],
      editedIndex: -1,
      editedItem: {
        oppo: '',
        status: '',
        contact: '',
        location: '',
      },
      defaultItem: {
        oppo: '',
        status: '',
        contact: '',
        location: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.invoices = [
          {
            oppo: 'Swedish Mafia',
            status: 'Planning',
            contact: 'Aldo A.',
            Location: 'New York MSG',
            date: new Date().toISOString().substr(0, 10),
            links: 'www.youtube.com',
          },
          {
            oppo: 'Unleash the Beast',
            status: 'Confirmed',
            contact: 'Bruce Banner',
            Location: 'Live on Twitch',
            date: new Date().toISOString().substr(0, 10),
            links: 'www.twitch.com',
          },
          {
            oppo: 'Moving Sons',
            status: 'Cancelled',
            contact: 'Faker',
            Location: 'Facebook Gaming',
            date: new Date().toISOString().substr(0, 10),
            links: 'https://www.facebook.com/gaming',
          },
        ]
      },

      editItem (item) {
        this.editedIndex = this.invoices.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.invoices.indexOf(item)
        confirm('Are you sure you want to delete this item?') &&
          this.invoices.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.invoices[this.editedIndex], this.editedItem)
        } else {
          this.invoices.push(this.editedItem)
        }
        this.close()
      },

      getColor (status) {
        if (status === 'Cancelled') return 'red'
        else if (status === 'Planning') return 'orange'
        else return 'green'
      },
      formatPrice (amount) {
        const val = (amount / 1).toFixed(2).replace('.', ',')
        return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
    },
  }
</script>
